<template>
  <b-dropdown position="is-bottom-right" aria-role="list" class="font-selector">
    <template #trigger="{ active }">
      <b-button :icon-right="active ? 'chevron-up' : 'chevron-down'" icon-pack="fas" class="trigger-button">
        <FontDisplay :fonts="value" />
      </b-button>
    </template>
    <b-dropdown-item
      @click="updateFonts(fonts)"
      v-for="fonts in fontPairs"
      :key="fonts.name"
      :class="{'is-active': value && fonts.name === value.name}"
      aria-role="listitem"
    >
      <FontDisplay :fonts="fonts" />
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
import { fontPairs } from '~/common/themeData'
import FontDisplay from '~/components/modals/deck-settings-modal/font-selector/FontDisplay'

export default {
  name: 'FontSelector',
  components: { FontDisplay },
  props: [
    'value'
  ],
  computed: {
    fontPairs () {
      return fontPairs
    }
  },
  methods: {
    updateFonts (fonts) {
      this.$emit('input', fonts)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~~/assets/css/components";

.font-selector {
  @include dropdown-selector;

  a.dropdown-item {
    padding: .5rem 1rem;
    &.is-active  {
      :deep(.title), :deep(.subtitle) {
        color: $white;
      }
    }
  }
}
</style>
